import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {

  connect() {
    this.reflect();
  }

  reflect() {
    dispatchCustomEvent(document, this.eventName, true, true, { value: this.element.value });
  }

  get eventName() {
    return `reflect-${this.element.id}`;
  }
}
